import { baseApi } from './base.api';

/**
 * Create APIs
 */
export const cookieApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    getXsrfToken: build.query<GetXsrfTokenRes, GetXsrfTokenReq>({
      query: () => ({
        url: '/sanctum/csrf-cookie',
      }),
    }),

    getCleancodeRedirectToken: build.query<GetCleancodeRedirectTokenRes, GetCleancodeRedirectTokenReq>({
      query: ({ zoneCode, token }) => ({
        url: `/r/${zoneCode}?token=${token}`,
      }),
    }),
  }),
});

/**
 * Hooks
 */
export const { useGetXsrfTokenQuery, useGetCleancodeRedirectTokenQuery } = cookieApi;

/**
 * Types
 */
type GetXsrfTokenRes = any;
type GetXsrfTokenReq = void;
type GetCleancodeRedirectTokenRes = any;
type GetCleancodeRedirectTokenReq = {
  zoneCode: string;
  token: string;
};
